import { tag, tagsContainer } from './Tags.css';

export const TagsCloud = ({ tags }: { tags: string[] }) => {
  return (
    <div className={tagsContainer}>
      {tags.map((v) => (
        <div className={tag} key={v}>
          {v}
        </div>
      ))}
    </div>
  );
};
